import { ReactNode } from "react"
import { makeStyles } from "tss-react/mui"
import { Box } from "@mui/material"

const useStyles = makeStyles()(() => ({
    list: {
        display: "grid",
        gridTemplateColumns: "1fr auto auto",
        columnGap: "1rem",
    },
}))

type OrderLineListProps = Readonly<{
    children: ReactNode
}>

export function OrderLineList({ children }: OrderLineListProps) {
    const { classes } = useStyles()

    return <Box className={classes.list}>{children}</Box>
}
